import React from 'react';
import Immutable from 'immutable';
import styled, {css} from 'styled-components';
import { defaultTheme } from '../../data/themes';
import Icon from '../icon';



const EMPTY_LIST = Immutable.List([]);


const Container = styled.div`
	outline: none;
	${props => props.large ? css`
		display: block;
	` : css`
		display: table;
	`}
	margin: ${props => props.theme.checkBoxPaneMargin || defaultTheme.checkBoxPaneMargin};
	padding: ${props => props.theme.checkBoxPanePadding || defaultTheme.checkBoxPanePadding};
`;

/*
		: '8px',
		: '8px',


*/

const Items = styled.div`
	${props => props.large ? css`
		display: grid;
		grid-template-columns: repeat(${props => props.columnCount || 2}, 1fr);
	` : css`
		display: table;
	`}
`;

const Item = styled.div`
	outline: none;
	margin: ${props => props.theme.checkBoxMargin || defaultTheme.checkBoxMargin};
	padding: ${props => props.theme.checkBoxPadding || defaultTheme.checkBoxPadding};
	white-space: nowrap;

	${props => props.large ? css`
		display: block;

		border: ${props => props.theme.checkBoxLargeBorder || defaultTheme.checkBoxLargeBorder};
		padding: ${props => props.theme.checkBoxLargePadding || defaultTheme.checkBoxLargePadding};
		margin: ${props => props.theme.checkBoxLargeMargin || defaultTheme.checkBoxLargeMargin};
		border-radius: ${props => props.theme.checkBoxLargeBorderRadius || defaultTheme.checkBoxLargeBorderRadius};
		background: ${props => props.theme.checkBoxLargeBackground || defaultTheme.checkBoxLargeBackground};
		opacity: ${props => props.theme.checkBoxLargeOpacity};

		.text {
			display: inline-block;
			font-size: ${props => props.theme.checkBoxTextFontSize || defaultTheme.checkBoxTextFontSize};
			font-weight: ${props => props.theme.checkBoxLargeTextFontWeight || defaultTheme.checkBoxLargeTextFontWeight};
			color: ${props => props.theme.checkBoxLargeTextColor || defaultTheme.checkBoxLargeTextColor};
		}

		.icon {
			font-size: ${props => props.theme.checkBoxLargeIconSize || defaultTheme.checkBoxLargeIconSize};
			color: ${props => props.theme.checkBoxLargeIconColor || defaultTheme.checkBoxLargeIconColor};
			margin-right: ${props => props.theme.checkBoxLargeIconMarginRight || defaultTheme.checkBoxLargeIconMarginRight};
		}

		&.checked {
			opacity: ${props => props.theme.checkBoxLargeCheckedOpacity};
			background: ${props => props.theme.checkBoxLargeCheckedBackground || defaultTheme.checkBoxLargeCheckedBackground};
			border: ${props => props.theme.checkBoxLargeCheckedBorder || defaultTheme.checkBoxLargeCheckedBorder};
			&.error {
				opacity: 0.3;
			}

			.text {
				font-weight: ${props => props.theme.checkBoxLargeCheckedTextFontWeight || defaultTheme.checkBoxLargeCheckedTextFontWeight};
				color: ${props => props.theme.checkBoxLargeCheckedTextColor || defaultTheme.checkBoxLargeCheckedTextColor};
			}

			.icon {
				color: ${props => props.theme.checkBoxLargeCheckedIconColor || defaultTheme.checkBoxLargeCheckedIconColor};
			}
		}

	` : css`
		display: inline-block;

		.text {
			display: inline-block;
			font-size: ${props => props.theme.checkBoxTextFontSize || defaultTheme.checkBoxTextFontSize};
			font-weight: ${props => props.theme.checkBoxTextFontWeight || defaultTheme.checkBoxTextFontWeight};
			color: ${props => props.theme.checkBoxTextColor || defaultTheme.checkBoxTextColor};
		}

		.icon {
			margin-right: ${props => props.theme.checkBoxIconMarginRight || defaultTheme.checkBoxIconMarginRight};
			font-size: ${props => props.theme.checkBoxIconSize || defaultTheme.checkBoxIconSize};
			color: ${props => props.theme.checkBoxIconColor || defaultTheme.checkBoxIconColor};
		}

		&.checked {
			&.error {
				opacity: 0.3;
			}

			.text {
				font-size: ${props => props.theme.checkBoxCheckedTextFontSize || defaultTheme.checkBoxCheckedTextFontSize};
				font-weight: ${props => props.theme.checkBoxCheckedTextFontWeight || defaultTheme.checkBoxCheckedTextFontWeight};
				color: ${props => props.theme.checkBoxCheckedTextColor || defaultTheme.checkBoxCheckedTextColor};
			}

			.icon {
				font-size: ${props => props.theme.checkBoxCheckedIconSize || defaultTheme.checkBoxCheckedIconSize};
				color: ${props => props.theme.checkBoxCheckedIconColor || defaultTheme.checkBoxCheckedIconColor};
			}
		}

	`}

	&:not(.disabled):not(.readOnly) {
		cursor: pointer;
		&:hover {
			.text {
				text-decoration: underline;
			}
		}
	}

	&.disabled {
		opacity: 0.3;
		cursor: default;
	}

	.icon {
		position: relative;
		top: -1px;
		display: inline-block;
	}

`;

const Label = styled.div`
	${props => props.large ? css`
		display: block;
		font-size: ${props => props.theme.checkBoxPaneLargeLabelFontSize || defaultTheme.checkBoxPaneLargeLabelFontSize};
		font-weight: ${props => props.theme.checkBoxPaneLargeLabelFontWeight || defaultTheme.checkBoxPaneLargeLabelFontWeight};
		margin: ${props => props.theme.checkBoxPaneLargeLabelMargin || defaultTheme.checkBoxPaneLargeLabelMargin};
	` : css`
		display: inline-block;
	`}
`;

export default class CheckBoxPane extends React.PureComponent {
	onChange(items) {
		if (this.props.onChange) {
			this.props.onChange(items);
		}
	}

	setItemChecked(index, checked) {
		let items = this.props.items || EMPTY_LIST;
		if (this.props.radio) {
			if (!items.getIn([index, 'checked'])) {
				this.onChange(items.map(item => item.delete('checked')).setIn([index, 'checked'], true));
			}
		} else {
			//this.onChange(items.set(index, item.set('checked', checked)));
			this.onChange(items.setIn([index, 'checked'], checked));
		}
	}

	render() {
		const items = this.props.items || EMPTY_LIST;

		const large = this.props.large;

		return (
			<Container className={'ps-checkBoxPane'} large={large} columnCount={this.props.columnCount}>
				{
					this.props.label && (
						<Label large={large}>{this.props.label}:</Label>
					)
				}
				<Items large={large} columnCount={this.props.columnCount}>
				{
					items.map((item, index) => {
						const checked = item.get('checked');
						const readOnly = item.get('readOnly');
						return (
							<Item
								key={index}
								large={large}
								className={(item.get('disabled') ? 'disabled' : '') + (checked ? ' checked' : '') + (item.get('error') ? ' error' : '') + (readOnly ? ' readOnly' : '')}
								tabIndex="-1"
								onMouseDown={e => {
									e.preventDefault();
									e.target.focus();
									if (item.get('disabled')) {
										return;
									}
									if (!readOnly) {
										this.setItemChecked(index, !checked);
									}
								}}
							>
								<Icon
									name={checked ? 'checked' : 'unchecked'}
								/>
								<span className="text">{item.get('text')}</span>
							</Item>
						)
					})
				}
				</Items>
			</Container>
		);
	}
}
